import script from "./BillingProfileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingProfileForm.vue?vue&type=script&setup=true&lang=js"

import "./BillingProfileForm.vue?vue&type=style&index=0&id=0285eacc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0285eacc"]])

export default __exports__